// extracted by mini-css-extract-plugin
module.exports = {"root":"P_bY","checked":"P_cV"};